import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class Calendars extends BaseModel {
  constructor() {
    super(collection(db, 'calendars'))
  }
}
